module.exports = __webpack_public_path__ + "assets/0691f3f5c47573b417945c9c839581b7.jpg";